import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiFormModule } from "@webapp/ui/form/form.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiInputModule } from "@webapp/ui/input/input.module";
import { UiLoadingIndicatorModule } from "@webapp/ui/loading-indicator/loading-indicator.module";
import { SaveFilterAsViewModalComponent } from "./components/save-filter-as-view-modal/save-filter-as-view-modal.component";
import { SaveFilterChangesComponent } from "./components/save-filter-changes/save-filter-changes.component";
import { ShareableFiltersApiService } from "./services/shareable-filters/shareable-filters-api.service";
import { ShareableFiltersFacade } from "./services/shareable-filters/shareable-filters-facade.service";
import { ShareableFiltersState } from "./services/shareable-filters/shareable-filters-state.service";

@NgModule({
  imports: [CommonModule, UiButtonModule, UiInputModule, UiGridModule, UiFormModule, FormsModule, ReactiveFormsModule, LocalizationModule, UiLoadingIndicatorModule],
  declarations: [SaveFilterChangesComponent, SaveFilterAsViewModalComponent],
  providers: [ShareableFiltersFacade, ShareableFiltersApiService, ShareableFiltersState],
})
export class UnifiedFiltersModule {}
